export default __webpack_public_path__ + "static/media/AEGIS-White.faca57cd.svg";